import React, { useEffect, useState } from "react";
import { Redirect } from "react-router-dom";
import { FormattedMessage } from "react-intl";

// @mui/icons-material
import { NotificationsActive } from "@mui/icons-material";

// core components
import Card from 'components/card/card';
import CardBody from 'components/card/cardBody';
import CardHeader from 'components/card/cardHeader';
import GridContainer from 'components/grid/gridContainer';
import GridItem from 'components/grid/gridItem';
import ListLoader from '../configuration/components/listLoader';
import SearchBar from 'components/List/components/SearchBar';
import Snackbar from "components/snackbar/snackbar";
import TableBody from "./components/tableBody";

// styles
import listStyle from "assets/jss/views/configuration/defaultListStyle";
import 'assets/css/ckeditor.css';

// api
import list from "api/brand/list";

// utils
import store from "store";
import { Authorizations, hasAuthorization } from "../../utils/authorizations";
import { withStyles } from "@mui/styles";

// Brands are managed content derived from products (card 2379): no create/delete here (creation is
// automatic on import, "deletion" is the enabled toggle on the edit form), so the list is read-only
// besides the edit action. Only brands with at least one online product are listed.
function List (props) {
    const { classes } = props;

    const [search, setSearch] = useState('');
    const [brands, setBrands] = useState(null);
    const [loading, setLoading] = useState(true);
    const [isErrorDisplayed, setErrorDisplayed] = useState(false);

    function refreshList() {
        setLoading(true);

        list("withOnlineProducts=true&withProductsCount=true&pagination=false")
            .then((retrieved) => setBrands(retrieved))
            .catch(() => setErrorDisplayed(true))
            .finally(() => setLoading(false));
    }

    useEffect(() => {
        refreshList();
    }, []);

    const authorizations = store.getState().authentication?.authorizations;
    if (false === hasAuthorization(authorizations, Authorizations.GLOBAL_ORGANIZATION_ESHOP_MANAGEMENT)) {
        return <Redirect to={'/'} />;
    }

    return (
        <div className={classes.containerWithSidebar}>
            <div className={classes.container}>
                <GridContainer>
                    <GridItem xs={12}>
                        <Card className={classes.card} style={{ background: "#fff" }}>
                            <CardHeader color="info">
                                <GridContainer alignItems={'center'} flexWrap={'nowrap'}>
                                    <GridItem xs={6} sm>
                                        <h3 style={{ margin: 0 }}>
                                            <FormattedMessage id={"brand.title"} />
                                        </h3>
                                    </GridItem>
                                    <GridItem xs={6}>
                                        <GridContainer justifyContent={'flex-end'}>
                                            <GridItem xs={12} sm={7}>
                                                <SearchBar
                                                    onChange={(value) => setSearch(value)}
                                                    customPlaceholder={"brand.search.placeholder"}
                                                />
                                            </GridItem>
                                        </GridContainer>
                                    </GridItem>
                                </GridContainer>
                            </CardHeader>
                            <CardBody>
                                <div className={classes.tableWrapper} style={{ marginTop: 0 }}>
                                    {brands === null && <ListLoader loading={loading} />}
                                    <div>
                                        <TableBody
                                            brands={brands}
                                            search={search}
                                            refreshList={refreshList}
                                        />
                                    </div>
                                </div>
                            </CardBody>
                        </Card>
                    </GridItem>
                </GridContainer>
            </div>
            <Snackbar
                open={isErrorDisplayed}
                close
                closeNotification={() => setErrorDisplayed(false)}
                place={"bl"}
                color={"danger"}
                icon={() => <NotificationsActive />}
                message={<FormattedMessage id={"list.error"} />}
            />
        </div>
    );
}

export default withStyles(listStyle)(List);
